import React from 'react';
import TesseractAnimation from './TesseractAnimation';
import './LogoWithTesseract.css';

const LogoWithTesseract = ({ logoSrc, logoAlt = 'Logo', size = 180 }) => {
  const logoScale = 0.45; // Smaller logo vs tesseract
  const logoOpacity = 0.92;
  const logoBrightness = 0.80;
  const tesseractOpacity = 0.25; // Slightly more visible tesseract
  const tesseractColor = '#ffffff';
  const logoOnTop = true;

  return (
    <div className="logo-with-tesseract" style={{ 
      width: size, 
      height: size,
    }}>
      {!logoOnTop && (
        <img 
          src={logoSrc} 
          alt={logoAlt} 
          className="logo-with-tesseract__logo"
          style={{ 
            width: size * logoScale, 
            opacity: logoOpacity,
            filter: `brightness(${logoBrightness})`,
          }}
        />
      )}
      <div 
        className="logo-with-tesseract__tesseract"
        style={{ opacity: tesseractOpacity }}
      >
        <TesseractAnimation size={size} color={tesseractColor} />
      </div>
      {logoOnTop && (
        <img 
          src={logoSrc} 
          alt={logoAlt} 
          className="logo-with-tesseract__logo"
          style={{ 
            width: size * logoScale, 
            opacity: logoOpacity,
            filter: `brightness(${logoBrightness})`,
          }}
        />
      )}
    </div>
  );
};

export default LogoWithTesseract;
